import {statusContainer} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Route, Routes} from 'react-router-dom';
import {HistoryRouter as Router} from 'redux-first-history/rr6';

import EnsureLoggedInLayout from './EnsureLoggedInLayout';

const Layout = ({config, history}) => (
  <div className={'dlFlexBoxPageContainer'}>
    <statusContainer.BackendInfoContainer config={config} />
    <Router history={history}>
      <div className={'dlFlexBoxPageContainer'}>
        <statusContainer.CheckNewAppVersionContainer config={config} />
        <Routes>
          <Route
            path={'*'}
            element={<EnsureLoggedInLayout config={config} />}
          />
        </Routes>
      </div>
    </Router>
  </div>
);

Layout.displayName = 'Layout';

Layout.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Layout;
